interface Step {
  number: number;
  label: string;
  icon: string;
}

interface StepIndicatorProps {
  steps: Step[];
  currentStep: number;
}

export default function StepIndicator({ steps, currentStep }: StepIndicatorProps) {
  return (
    <div className="w-full mb-10">
      {/* Desktop */}
      <div className="hidden sm:flex items-center justify-between relative">
        {/* Connecting line */}
        <div className="absolute top-5 left-0 right-0 h-0.5 bg-gray-200 z-0">
          <div
            className="h-full bg-primary transition-all duration-500 ease-out"
            style={{ width: `${((currentStep - 1) / (steps.length - 1)) * 100}%` }}
          />
        </div>

        {steps.map((step) => {
          const isDone = step.number < currentStep;
          const isActive = step.number === currentStep;
          return (
            <div key={step.number} className="relative z-10 flex flex-col items-center gap-2">
              <div
                className={`w-10 h-10 rounded-full flex items-center justify-center text-sm font-bold transition-all duration-300 border-2 ${
                  isDone
                    ? 'bg-primary border-primary text-white'
                    : isActive
                    ? 'bg-white border-primary text-primary scale-110'
                    : 'bg-white border-gray-200 text-gray-400'
                }`}
              >
                {isDone ? (
                  <i className="ri-check-line text-base"></i>
                ) : (
                  <i className={`${step.icon} text-base`}></i>
                )}
              </div>
              <span
                className={`text-xs font-semibold whitespace-nowrap transition-colors duration-300 ${
                  isActive ? 'text-primary' : isDone ? 'text-gray-600' : 'text-gray-400'
                }`}
              >
                {step.label}
              </span>
            </div>
          );
        })}
      </div>

      {/* Mobile — compact */}
      <div className="flex sm:hidden items-center gap-3 mb-4">
        <div className="flex items-center gap-1">
          {steps.map((step) => (
            <div
              key={step.number}
              className={`h-1.5 rounded-full transition-all duration-300 ${
                step.number === currentStep
                  ? 'w-8 bg-primary'
                  : step.number < currentStep
                  ? 'w-4 bg-primary/60'
                  : 'w-4 bg-gray-200'
              }`}
            />
          ))}
        </div>
        <span className="text-xs text-gray-500 font-medium">
          Passo {currentStep} de {steps.length}
        </span>
      </div>
    </div>
  );
}